import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FormDivider from '../FormDivider'

import ToggleInput from './ToggleInput'
import ReminderArrayInputs from './RemindersArrayInput'
import CheckboxInput from './CheckboxInput'

const AutomatedRemindersSection = ({
  automatedRemindersToggle,
  remindRsvp,
  remindRsvpValues,
  remindAll,
  remindAllValues,
  timeStart,
  setFieldValue,
  displayRemindRsvpSection = true,
}) => {
  const { t } = useTranslation(['eventManagement'])

  return (
    <React.Fragment>
      <div className="columns">
        <ToggleInput
          columnSize={12}
          name="automatedRemindersToggle"
          value={automatedRemindersToggle}
          label={t('eventManagement:common.setupAutomatedReminders')}
          tooltip={
            <>
              <p>{t('eventManagement:common.automatedRemindersTooltipLine1')}</p>
              <p>{t('eventManagement:common.automatedRemindersTooltipLine2')}</p>
              <p>{t('eventManagement:common.automatedRemindersTooltipLine3')}</p>
            </>
          }
          onToggle={(name, checked) => {
            setFieldValue(name, checked)

            if (displayRemindRsvpSection) {
              setFieldValue('remindRsvp', false)
              setFieldValue('remindRsvpValues', [''])
            }

            setFieldValue('remindAll', false)
            setFieldValue('remindAllValues', [''])
          }}
        />
      </div>
      {automatedRemindersToggle && (
        <React.Fragment>
          {displayRemindRsvpSection && (
            <React.Fragment>
              <div className="columns">
                <CheckboxInput
                  columnSize={12}
                  name="remindRsvp"
                  label={t('eventManagement:common.remindAttendeesWhoRsvpd')}
                  value={remindRsvp}
                  setFieldValue={(name, value) => {
                    setFieldValue(name, value)
                    setFieldValue('remindRsvpValues', [''])
                  }}
                />
              </div>
              {remindRsvp && (
                <ReminderArrayInputs
                  name="remindRsvpValues"
                  values={remindRsvpValues}
                  timeStart={timeStart}
                  setFieldValue={setFieldValue}
                />
              )}

              <FormDivider />
            </React.Fragment>
          )}

          <div className="columns">
            <CheckboxInput
              columnSize={12}
              name="remindAll"
              label={t('eventManagement:common.remindEveryone')}
              value={remindAll}
              setFieldValue={(name, value) => {
                setFieldValue(name, value)
                setFieldValue('remindAllValues', [''])
              }}
            />
          </div>
          {remindAll && (
            <ReminderArrayInputs
              name="remindAllValues"
              values={remindAllValues}
              timeStart={timeStart}
              setFieldValue={setFieldValue}
            />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

AutomatedRemindersSection.propTypes = {
  automatedRemindersToggle: PropTypes.bool,
  remindRsvp: PropTypes.bool,
  remindRsvpValues: PropTypes.array,
  remindAll: PropTypes.bool,
  remindAllValues: PropTypes.array,
  timeStart: PropTypes.object,
  setFieldValue: PropTypes.func.isRequired,
  displayRemindRsvpSection: PropTypes.bool,
}

export default AutomatedRemindersSection
